export class PAGE_URL {
  public static HOME = "/";
  public static SIGN_UP = "/sign-up";
  public static SIGN_UP_CODE_CONFIRMATION = "/sign-up/code-confirmation";
  public static SIGN_UP_CHECKBOX = "/sign-up/jobs-types";
  public static SIGN_UP_PROJECT = "/sign-up/project";
  public static AUDIT_MANAGEMENT_DETAILS = "/poll/answer/detail/:id";
  public static AUDIT_MANAGEMENT_LIST = "/poll/answer/list";
  public static AUDIT_MANAGEMENT_MAP = "/poll/answer/map";
  public static AUDIT_MANAGEMENT_DRAFT = "/poll/answer/draft";

  public static AUDIT_MANAGEMENT_EXPORT = "/poll/answer/export";
  public static AUDIT_MANAGEMENT_ENTRIES = "/poll/answer/entries";
  public static AUDIT_MANAGEMENT_UPDATE_ANSWER = "/poll/answer/:id/update";
  public static AUDIT_MANAGEMENT_OLD_NEW_ANSWER = "/poll/:id/old/answer/new";
  public static AUDIT_MANAGEMENT_NEW_ANSWER = "/poll/:id/answer/new";
  public static AUDIT_MANAGEMENT_DASHBOARD = "/poll/dashboard";
  public static AUDIT_MANAGEMENT_FORMS = "/poll/forms";
  public static AUDIT_MANAGEMENT_EXTERNAL_DATA = "/poll/external-data";
  public static AUDIT_MANAGEMENT_EXTERNAL_DATA_DETAIL =
    "/poll/external-data/:id";
  public static AUDIT_MANAGEMENT_EXTERNAL_DATA_EDIT =
    "/poll/external-data/:id/edit";
  public static FORMS_MANAGEMENT = "/poll/manager";
  public static FORMS_MANAGEMENT_TEAMS = "/poll/manager/teams";
  public static FORMS_MANAGEMENT_FAVORITES = "/poll/manager/list/favorites";
  public static POLL_NEW = "/poll/new";
  public static POLL_NEW_WITH_SCHEMA = "/poll/new/:schema";
  public static POLL_IMPORT = "/poll/import";
  public static POLL_UPDATE = "/poll/:id/update";
  public static POLL_DELETE = "/poll/:id/delete";
  public static POLL_ANSWER_DELETE = "/poll/answer/:id/delete";
  public static AUDIT_MANAGEMENT = "/poll/";
  public static CATEGORY_POLL_LIST = "/categorypoll";
  public static CATEGORY_POLL_NEW = "/categorypoll/new";
  public static CATEGORY_POLL_UPDATE = "/categorypoll/:id/update";
  public static CATEGORY_POLL_DELETE = "/categorypoll/:id/delete";
  public static MAINTENANCE = "/maintenance";
  public static MAINTENANCE_NEW = "/maintenance/new";
  public static MAINTENANCE_DETAIL = "/maintenance/:id";
  public static MAINTENANCE_EDIT = "/maintenance/:id/edit";
  public static MAINTENANCE_RUNS = "/maintenance/:id/runs";
  public static MAINTENANCE_AUDIT_FORM = "/maintenance/auditform/list";
  public static WORKSPACE_MANAGEMENT = "/workspace/list";
  public static TEAMS_MANAGEMENT = "/teams/list";
  public static REPORT_TEMPLATE_LIST = "/settings/report/creator/list";
  public static REPORT_TEMPLATE_NEW = "/report/creator/new";
  public static SETTINGS = "/settings";
  public static MAP = "/settings/map";
  public static SETTINGS_JOB_TYPE = "/settings/job-type";
  public static SETTINGS_JOB_TYPE_TASKS = "/settings/job-type/tasks";
  public static SETTINGS_JOB_TYPE_CUSTOM_FIELDS =
    "/settings/job-type/custom-fields";
  public static SETTINGS_JOB_TYPE_MICRO_REPORT =
    "/settings/job-type/micro-report";
  public static SETTINGS_MAINTENANCE = "/settings/maintenance";
  public static SETTINGS_APP = "/settings/app";
  public static SETTINGS_APP_PHOTO_QUALITY = "/settings/app/photo-quality";
  public static SETTINGS_DEMO_DATA = "/settings/demo-data";
  public static SCHEDULER = "/scheduler";
  public static SCHEDULER_DASHBOARD = "/scheduler/dashboard";
  public static TECHNICIAN_LIST = "/scheduler/technicians";
  public static TIMESHEETS = "/timesheets";
  public static SETTINGS_TIMESHEETS = "/settings/timesheets";
  public static SETTINGS_TIMESHEETS_SECTION = "/settings/timesheets/:section";
  public static TIMESHEETS_KIOSK = "/kiosk";
  public static SETTINGS_SCHEDULER = "/settings/scheduler";
  public static SETTINGS_UNPLANNED_WO = "/settings/unplannedWo";
  public static SETTINGS_APPROVAL_FLOWS = "/settings/work-order/approval-flows";
  public static SETTINGS_APPROVAL_FLOW_NEW =
    "/settings/work-order/approval-flows/new";
  public static SETTINGS_APPROVAL_FLOW_EDIT =
    "/settings/work-order/approval-flows/:id";
  public static APPROVALS_INBOX = "/operations/approvals";
  public static SETTINGS_FREQUENT_WORK_ITEMS = "/settings/frequent-work-items";
  public static SETTINGS_TRACKER_TEMPLATES = "/settings/project-templates";
  public static SETTINGS_NOTIFICATIONS = "/settings/notifications";
  public static SETTINGS_AUDIT_LOG = "/settings/governance/audit-log";
  public static SETTINGS_OTHERS = "/settings/others";
  public static SETTINGS_INVENTORY = "/settings/inventory";
  public static SETTINGS_INVENTORY_CATALOG = "/settings/inventory/catalog";
  public static SETTINGS_INVENTORY_WAREHOUSES =
    "/settings/inventory/warehouses";
  public static SETTINGS_INVENTORY_JOB_TYPES = "/settings/inventory/job-types";
  public static ERROR_404 = "/not-found";
  public static ERROR_PAGE = "/error-page";
  public static BREADCRUMB_DASHBOARD_MANAGEMENT = "/dashboardbreadcrumb/list";
  public static NEW_BREADCRUMB_DASHBOARD = "/dashboardbreadcrumb/new";
  public static UPDATE_BREADCRUMB_DASHBOARD = "/dashboardbreadcrumb/:id/update";
  public static DELETE_BREADCRUMB_DASHBOARD = "/dashboardbreadcrumb/:id/delete";
  public static INBOX_MANAGEMENT_LIST = "/inbox/list";
  public static DASHBOARD_TEMPLATE = "/dashboard/template";
  public static LAYOUT_DASHBOARD_MANAGEMENT = "/settings/dashboard/list";
  public static LAYOUT_DASHBOARD_UPDATE = "/settings/dashboards/:id/update";
  public static LAYOUT_DASHBOARD_DELETE = "/settings/dashboards/:id/delete";
  public static LAYOUT_DASHBOARD_NEW = "/settings/dashboards/new";
  public static LAYOUT_DASHBOARD_WIDGETS = "/dashboards/:id/widget";
  public static LAYOUT_DASHBOARD_WIDGETS_NEW = "/dashboards/:id/widget/new";
  public static LAYOUT_DASHBOARD_WIDGETS_UPDATE =
    "/dashboards/:id/widget/:widgetId/update";
  public static LAYOUT_DASHBOARD_WIDGETS_DELETE =
    "/dashboards/:id/widget/:widgetId/delete";
  public static USER_MANAGEMENT = "/settings/accounts/user/list";
  public static NEW_USER = "/settings/accounts/user/create";
  public static UPDATE_USER = "/settings/accounts/user/:id/update";
  public static CHANGE_PASSWORD = "/settings/accounts/user/:id/change-password";
  public static USER_DELETE = "/settings/accounts/user/:id/delete";
  public static USER_ACTIVITY = "/settings/accounts/activities/list";
  public static USER_PROFILE_HOME = "/accounts/profile";
  public static MY_PROFILE = "/accounts/profile/my-profile";
  public static NOTIFICATIONS_PREFERENCES =
    "/accounts/profile/notifications-preferences";
  public static LOGOUT = "/accounts/logout";

  public static PERMISSION_PROFILE_MANAGEMENT =
    "/settings/accounts/permission-profile/list";
  public static PERMISSION_PROFILE_NEW =
    "/settings/accounts/permission-profile/new";
  public static PERMISSION_PROFILE_UPDATE =
    "/settings/accounts/permission-profile/:id/update";
  public static PERMISSION_PROFILE_VIEW =
    "/settings/accounts/permission-profile/:id/view";
  public static SETTINGS_COMPANY = "/settings/company";
  public static SETTINGS_DOCUMENT_TYPES = "/settings/document-types";
  public static USER_COMPANY = "/settings/accounts/owncompany/list";
  public static USER_COMPANY_NEW = "/settings/accounts/owncompany/new";
  public static USER_COMPANY_UPDATE =
    "/settings/accounts/owncompany/:id/update";
  public static USER_COMPANY_DELETE =
    "/settings/accounts/owncompany/:id/delete";

  public static USER_BUSINESS = "/accounts/business/list";
  public static USER_BUSINESS_NEW = "/accounts/business/new";
  public static USER_BUSINESS_UPDATE = "/accounts/business/:id/update";
  public static USER_BUSINESS_DELETE = "/accounts/business/:id/delete";
  public static USER_SECURITY = "/settings/accounts/user-security";
  public static EQUIPMENTS_MANAGEMENT = "/equipments";
  public static EQUIPMENTS_MANAGEMENT_STOCK_CONTROL = "/equipments/list";
  public static INVENTORY = "/inventory";

  // public static BATTERIES_MANAGEMENT_ADD_BATTERY = '/batteryequipments/add-battery'
  // public static  BATTERIES_MANAGEMENT_RETURN_BATTERY = '/batteryequipments/return-battery'
  public static NEW_FIELD_MODEL_MANAGEMENT = "/fieldmodels/new/list/:model/";
  public static FIELD_MODEL_MANAGEMENT_EDIT = "/fieldmodels/edit/:id/";
  public static FIELD_MODEL_MANAGEMENT_CREATE = "/fieldmodels/create";
  public static FIELD_MODEL_MANAGEMENT_IMPORT = "/fieldmodels/import";
  public static MODEL_VIEWS = "/networks/model-view/:id";
  public static ENTITY_DETAIL = "/networks/entity-detail/:uuid/:local_id";
  public static ASSET_PHOTO_GALLERY =
    "/networks/entity-detail/:uuid/:local_id/photo-gallery";
  public static ASSET_PHOTO_GALLERY_HISTORY =
    "/networks/entity-detail/:uuid/:local_id/photo-gallery/types/:typepicture_id/history";
  public static DRIVE_TEST_CONTROL = "/drive-test-control/";
  public static DRIVE_TEST_CONTROL_DASHBOARD = "/drive-test-control/dashboard";
  public static DRIVE_TEST_CONTROL_CONFIG = "/drive-test-control/config";
  public static DRIVE_TEST_CONTROL_NEW = "/drive-test-control/new";
  public static DRIVE_TEST_CONTROL_UPDATE = "/drive-test-control/:id/update";
  public static DRIVE_TEST_CONTROL_COLLECTION_CYCLE_NEW =
    "/drive-test-control/:id/collection-cycle/new";
  public static DRIVE_TEST_CONTROL_COLLECTION_CYCLE_UPDATE =
    "/drive-test-control/:id/collection-cycle/:cycleId/update";
  public static SITE_VISITS = "/sitevisit/";
  public static SITE_VISITS_DASHBOARD = "/sitevisit/dashboard";
  public static SITE_VISITS_LIST = "/sitevisit/list";
  public static SITE_VISITS_WORK_IN_PROGRESS = "/sitevisit/work-in-progress";
  public static SITE_VISITS_TRACKER_LIST = "/sitevisit/tracker/list";
  public static SITE_VISITS_REAL_TIME_LIST = "/sitevisit/real/time/list";
  public static SITE_VISITS_BROADCASTER = "/sitevisit/broadcaster/list";
  public static GROUP_REALTIME_NEW = "/group/realtime/new";
  public static GROUP_REALTIME_DELETE = "/group/realtime/:id/delete";
  public static GROUP_REALTIME_UPDATE = "/group/realtime/:id/update";
  public static REALTIME_LIST = "/real/time/list";
  public static NETWORK_ELEMENT = "/networks";
  public static NETWORK_ELEMENT_LIST = "/networks/list";
  public static NETWORK_ELEMENT_DETAILS = "/networks/:id";
  public static NETWORK_ELEMENT_VIEW = "/networks/:network/element/:id/";
  public static NETWORK_ELEMENT_FORM_BEGIN = "/networks/element/form/begin";
  public static NETWORK_ELEMENT_FORM_BASIC_CARDS =
    "/networks/element/form/basic-card/:id";
  public static NETWORK_ELEMENT_BASIC_CARDS_IMPORT =
    "/networks/element/form/basic-card/import";
  public static NETWORK_ELEMENT_FORM_FINISH = "/networks/element/form/finish";
  public static NETWORK_ELEMENT_CUSTOM =
    "/networks/:id/element/form/custom-cards/:card";
  public static NETWORK_ELEMENT_FORM_SYSTEM_CARDS =
    "/networks/element/form/system-cards/:id";
  public static NETWORK_ELEMENT_FORM_MODULES =
    "/networks/element/form/modules/:id";
  public static NETWORK_ELEMENT_FORMBUILDER_MODELS_ADD =
    "/networks/:network/element/formbuilder/model/new";
  public static NETWORK_ELEMENT_PAGEBUILDER =
    "/networks/:network/element/pagebuilder/model/:id";
  public static NETWORK_ELEMENT_FORMBUILDER_MODELS_EDIT =
    "/network/:network/formbuilder/model/:model";
  public static WORK_ORDER = "/pendingissues/list";
  public static WORK_ORDER_TEMPLATES = "/pendingissues/templates";
  public static WORK_ORDER_SITE_CHECK = "/pendingissues/list";
  /** Serial conflict of a WO proposal (FE #3425), also linked from Incidencias. */
  public static WORK_ORDER_SERIAL_CONFLICT =
    "/pendingissues/serial-conflicts/:id";
  public static NETWORK_ELEMENT_PAGEBUILDER_NEW =
    "/networks/:network/pagebuilder/:schema";
  public static NETWORK_ELEMENT_PAGEBUILDER_EDIT =
    "/networks/:network/pagebuilder/:schema/:id";
  public static NETWORK_ELEMENT_FORMBUILDER_NEW =
    "/networks/:network/element/formbuilder/network";
  public static NETWORK_ELEMENT_FORMBUILDER_NEW_EDIT =
    "/networks/:network/element/formbuilder/network/:id";
  public static NETWORK_ELEMENT_FORM_NEW =
    "/networks/:network/element/form/schema/:id";
  public static NETWORK_ELEMENT_FORM_NEW_EDIT =
    "/networks/:network/element/form/schema/:id/entity/:entity";
  public static DOCUMENTS = "/documents";
  public static PICTURE_MANAGEMENT = "/poll/typepicture/list";
  public static FORM_PICTURE_MANAGEMENT = "/poll/typepicture/list";
  public static TEMPLATE_BUILDER = "/poll/typepicture/builder";
  public static RUN_MEDIA_CHECKLIST = "/poll/typepicture/run";
  public static SIGN_IN = "/sign-in";
  public static PASSWORD_SET = "/password";
  public static PASSWORD_RECOVERY = "/password-recovery";
  public static USER_INACTIVE = "/user-inactive";
  public static ACCESS_NOT_CONFIGURED = "/access-not-configured";
  public static NOTIFICATIONS = "/notifications";
  public static NOTIFICATIONS_DETAIL = "/notifications/:notificationId";
  public static OPERATIONS_OVERVIEW = "/operations/overview";
  public static ASSET_SEARCH = "/insights/asset-search";
  public static ASSET_SEARCH_SAVED = "/insights/asset-search/saved";
  public static FORM_ANALYSIS = "/insights/form-analysis";
  public static BULK_OPERATIONS = "/bulk-operations";
  public static BULK_OPERATIONS_DASHBOARD = "/bulk-operations/dashboard";
  public static BULK_OPERATIONS_PROCESS = "/bulk-operations/:id";
  public static BULK_OPERATIONS_NEW = "/bulk-operations/new";
  public static PROJECTS = "/projects";
  public static PROJECTS_CREATE = "/projects/create";
  public static PROJECTS_DETAIL = "/projects/:id";
  public static PROJECTS_UPDATE = "/projects/:id/update";
  public static LIBRARY = "/library";
  public static LIBRARY_FORMS = "/library/templates";
  public static LIBRARY_FORMS_NEW = "/library/templates/new";
  public static LIBRARY_FORMS_IMPORT = "/library/templates/import";
  public static LIBRARY_FORMS_DETAIL = "/library/templates/:id";
  public static LIBRARY_EXTERNAL_DATA = "/library/templates/external-data";
  public static LIBRARY_EXTERNAL_DATA_DETAIL =
    "/library/templates/external-data/:id";
  public static LIBRARY_EXTERNAL_DATA_EDIT =
    "/library/templates/external-data/:id/edit";
  public static LIBRARY_MEDIA = "/library/media-templates";
  public static LIBRARY_MEDIA_DETAIL = "/library/media-templates/:id";
  public static LIBRARY_MEDIA_NEW = "/library/media-template/new";
  public static LIBRARY_SCHEMAS = "/library/schemas";
  public static LIBRARY_SCHEMAS_DETAIL =
    "/library/networks/:network/schema/:id";
  public static LIBRARY_SCHEMAS_NEW = "/library/networks/:network/schemas/";
}

export const APP_MODULES = {
  DASHBOARD_MODULE: "DASHBOARD_MODULE",
  WORK_ORDER_MODULE: "WORK_ORDER_MODULE",
  ASSETS_MODULE: "ASSETS_MODULE",
  INVENTORY_MODULE: "INVENTORY_MODULE",
  FORM_MODULE: "FORM_MODULE",
  FORM_AUDIT_MODULE: "FORM_AUDIT_MODULE",
  SITE_MODULE: "SITE_MODULE",
  SITE_VISIT_MODULE: "SITE_VISIT_MODULE",
  LIBRARY_MODULE: "LIBRARY_MODULE",
  MESSAGE_MODULE: "MESSAGE_MODULE",
  QR_MODULE: "QR_MODULE",
  ADMIN_ROLE_MODULE: "ADMIN_ROLE_MODULE",
  TEAM_MODULE: "TEAM_MODULE",
  WORKSPACE_MODULE: "WORKSPACE_MODULE",
  SETTINGS_MODULE: "SETTINGS_MODULE",
  REPORTS_MODULE: "REPORTS_MODULE",
  DOCUMENTS_MODULE: "DOCUMENTS_MODULE",
  PICTURE_MODULE: "PICTURE_MODULE",
  PROJECT_MODULE: "PROJECT_MODULE",
  OPERATIONAL_TRACKER_MODULE: "OPERATIONAL_TRACKER_MODULE",
  TIMESHEET_MODULE: "TIMESHEET_MODULE"
} as const;

export class LOCAL_STORAGE_KEYS {
  public static VISITED_LOBBY = "VISITED_LOBBY";
  public static REFRESH_TOKEN = "refresh_token";
}

export * from "./maintenance";
export * from "./work-order-priority";
